import React from 'react';
export function SchoolWireframe() {
  return <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] opacity-30 pointer-events-none z-0" data-id="element-14">
      <svg viewBox="0 0 800 400" className="w-full h-full drop-shadow-[0_0_15px_rgba(0,240,255,0.5)]" data-id="element-15">
        <defs data-id="element-16">
          <linearGradient id="wireframe-gradient" x1="0%" y1="0%" x2="0%" y2="100%" data-id="element-17">
            <stop offset="0%" stopColor="#00F0FF" stopOpacity="0.8" data-id="element-18" />
            <stop offset="100%" stopColor="#0066FF" stopOpacity="0.1" data-id="element-19" />
          </linearGradient>
        </defs>

        {/* Abstract School Building Structure */}
        <g stroke="url(#wireframe-gradient)" strokeWidth="1.5" fill="none" data-id="element-20">
          {/* Main Building Center */}
          <path d="M300,350 L300,200 L400,150 L500,200 L500,350" className="animate-pulse" data-id="element-21" />
          <path d="M300,200 L500,200" data-id="element-22" />
          <path d="M400,150 L400,350" strokeDasharray="5,5" data-id="element-23" />

          {/* Left Wing */}
          <path d="M150,350 L150,250 L300,200" data-id="element-24" />
          <path d="M150,250 L300,250" data-id="element-25" />

          {/* Right Wing */}
          <path d="M650,350 L650,250 L500,200" data-id="element-26" />
          <path d="M500,250 L650,250" data-id="element-27" />

          {/* Ground Grid */}
          <path d="M50,350 L750,350" strokeWidth="2" data-id="element-28" />
          <path d="M100,380 L700,380" strokeWidth="1" opacity="0.5" data-id="element-29" />

          {/* Decorative Circles/Nodes */}
          <circle cx="400" cy="150" r="4" fill="#00F0FF" className="animate-ping-slow" data-id="element-30" />
          <circle cx="300" cy="200" r="3" fill="#00F0FF" data-id="element-31" />
          <circle cx="500" cy="200" r="3" fill="#00F0FF" data-id="element-32" />
        </g>

        {/* Energy Ring Base */}
        <ellipse cx="400" cy="350" rx="300" ry="30" stroke="#00F0FF" strokeWidth="1" fill="none" opacity="0.3" className="animate-pulse-slow" data-id="element-33" />
        <ellipse cx="400" cy="350" rx="250" ry="20" stroke="#0066FF" strokeWidth="1" fill="none" opacity="0.2" data-id="element-34" />
      </svg>

      {/* Light Beams */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-t from-tech-blue/20 to-transparent blur-3xl -z-10" data-id="element-35" />
    </div>;
}